(function() {
    angular
        .module("dashboard")
        .controller("OrderUpOutstandingOrdersModalController", [
            "$scope",
            "$uibModalInstance",
            "$state",
            "toState",
            "cancelled",
            OrderUpOutstandingOrdersModalController]);

    function OrderUpOutstandingOrdersModalController(
        $scope,
        $uibModalInstance,
        $state,
        toState,
        cancelled
    ) {
        $scope.cancel = () => {
            cancelled();
            $uibModalInstance.close();
        };
        $scope.leave = function() {
            $uibModalInstance.close();
            window.location.href = toState;
        }
    }
})();
